import { render } from "./FrontEndHeader.vue?vue&type=template&id=254cb65d"
import script from "./FrontEndHeader.vue?vue&type=script&lang=js"
export * from "./FrontEndHeader.vue?vue&type=script&lang=js"
script.render = render

export default script